module.exports = __webpack_public_path__ + "static/footer-desktop-e2db6003f8b83aa3b27c1f5a2139a7d3.svg";